(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3912],{

/***/ 34490:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var isStoreOpenNow = function(store) {
    var ref;
    var itsOpenNow = store === null || store === void 0 ? void 0 : (ref = store.schedule) === null || ref === void 0 ? void 0 : ref.itsOpenNow;
    return itsOpenNow;
};
/* harmony default export */ __webpack_exports__["Z"] = (isStoreOpenNow);


/***/ }),

/***/ 53912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NextOpenDateWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/websites/isStoreOpenNow.ts
var isStoreOpenNow = __webpack_require__(34490);
// EXTERNAL MODULE: ./src/helpers/dayjs/index.ts
var dayjs = __webpack_require__(70457);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/page-components/Order/NextOpenDate/styles.module.css
var styles_module = __webpack_require__(94148);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/NextOpenDate/NextOpenDate.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getStoreCapacityForNextOpenDate($storeId: ID!, $websiteId: ID!, $deliverAt: Date) {\n        store(storeId: $storeId) {\n          _id\n          hasOrderCapacity(date: $deliverAt)\n        }\n        website(websiteId: $websiteId) {\n          _id\n          limitOrdersBySlot\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function NextOpenDate(props) {
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.nextOpenDate"
    }).t;
    var store = props.store, deliverAt = props.deliverAt;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var ref = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            storeId: store._id,
            websiteId: websiteId,
            deliverAt: deliverAt
        },
        fetchPolicy: "cache-first"
    }), storeCapacity = ref.store, website = ref.website;
    var closedMessage = !(storeCapacity === null || storeCapacity === void 0 ? void 0 : storeCapacity.hasOrderCapacity) && (website === null || website === void 0 ? void 0 : website.limitOrdersBySlot) ? "Hemos recibido todos los pedidos que podemos procesar en este momento, \xbfQu\xe9 tal si programas tu pedido para m\xe1s tarde?" : null;
    var nextDate = store.nextAvailableDate;
    var schedulingOrdersDays = store.schedulingOrdersDays;
    var className = [
        (styles_module_default()).container,
        props.className
    ].join(" ");
    var schedulingClassName = [
        (styles_module_default()).scheduling,
        props.className
    ].join(" ");
    if (closedMessage) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: schedulingClassName,
            children: closedMessage
        });
    }
    if (!nextDate) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            children: t("labelClosedNow")
        });
    }
    var date = (0,dayjs/* default */.Z)(nextDate);
    if (date.isSame((0,dayjs/* default */.Z)(), "day")) {
        if (schedulingOrdersDays) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: schedulingClassName,
                children: t("labelScheduleOrderAfter", {
                    date: date.format("HH:mm")
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            children: t("labelClosedUntil", {
                date: date.format("HH:mm")
            })
        });
    }
    if (date.isSame((0,dayjs/* default */.Z)().add(1, "day"), "day")) {
        if (schedulingOrdersDays >= 2) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: schedulingClassName,
                children: t("labelScheduleOrderTomorrow")
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            children: t("labelClosedUntilTomorrow", {
                date: date.format("HH:mm")
            })
        });
    }
    if (schedulingOrdersDays >= 3) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: schedulingClassName,
            children: t("labelScheduleOrderFrom", {
                date: date.format("dddd D [de] MMMM")
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: t("labelClosedUntilDate", {
            date: date.format("LL"),
            hour: date.format("HH:mm")
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/NextOpenDate/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function NextOpenDateWrapper(props) {
    var store = props.store;
    if (!store) return null;
    var itsOpenNow = (0,isStoreOpenNow/* default */.Z)(store);
    if (itsOpenNow) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextOpenDate, _objectSpread({}, props));
};


/***/ }),

/***/ 94148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1p4i0Q6FHN2JmlK1-Aq9gW","scheduling":"z5vfYbOpyPAIVionHNmzq _1p4i0Q6FHN2JmlK1-Aq9gW"};

/***/ })

}]);